import { useRef } from "react";
import { useUserContext } from "../../context/userContext";

import { useContext } from "react";
import { DarkModeContext } from "../DarkModeProvider"


const SignUp = ({ toggleIndex, index }) => {
  const emailRef = useRef();
  const nameRef = useRef();
  const psdRef = useRef();

  const { registerUser } = useUserContext();

  const onSubmit = (e) => {
    e.preventDefault();
    const email = emailRef.current.value;
    const name = nameRef.current.value;
    const password = psdRef.current.value;
    if (email && name && password) registerUser(email, name, password);
  };

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={darkMode ? 'auth dark' : 'auth light'}>
        <div className="container">
          <div className="auth__container">
            <h2 className={darkMode ? 'dark-text' : 'light-text'}>Zaregistrovat se</h2>
            <form className="auth__content" onSubmit={onSubmit}>
              <div className="auth__content--input">
                <label className={darkMode ? 'dark-second-text' : 'light-second-text'} htmlFor="email">Email</label>
                <input type="email" ref={emailRef} />
              </div>
              <div className="auth__content--input">
                <label className={darkMode ? 'dark-second-text' : 'light-second-text'} htmlFor="Name">Uživatelské Jméno</label>
                <input type="name" ref={nameRef} />
              </div>
              <div className="auth__content--input">
                <label className={darkMode ? 'dark-second-text' : 'light-second-text'} htmlFor="password">Heslo</label>
                <input type="Password" ref={psdRef} />
              </div>

              <button className={darkMode ? 'auth__content--button dark-button-text' : 'auth__content--button'} type="submit">
                <span>
                    Pokračovat
                </span>
              </button>
            </form>
            <p className={darkMode ? 'auth__login dark-text' : 'auth__login light-text'} onClick={toggleIndex}>
                Máte již účet? <strong>Přihlaste se</strong>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignUp;
